var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('Title',{attrs:{"title":"服务长者情况分析"}}),_c('Nav',{attrs:{"dataArray":_vm.components,"callBack":_vm.callBack}}),_c('div',{staticClass:"layout-view withoutTitleAndNav"},[_c(_vm.currentComponent,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }